(()=>{
'use strict';
if(window.AWOccasionPassportQR?.version)return;
const VERSION='2.28.0';
const PARAM='aw_passport';
const K={replicas:'aw_garage_replicas_v1',timeline:'aw_upgrade_timeline_v1',active:'aw_garage_active_replica_v1'};
const root=()=>document.querySelector('[data-aw-mon-atelier-center-p21]');
const banner=()=>document.querySelector('[data-aw-p228-passport-access]');
const read=(k,f)=>{try{const v=JSON.parse(localStorage.getItem(k)||'null');return v??f}catch(_){return f}};
const write=(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));return true}catch(_){return false}};
const arr=v=>Array.isArray(v)?v:[];
const text=v=>String(v??'').trim();
const token=()=>new URL(location.href).searchParams.get(PARAM)||'';
const setBanner=(state,title,body,actionHtml='')=>{
  const n=banner(); if(!n)return;
  n.hidden=false;
  n.dataset.state=state;
  n.innerHTML=`<div><span class="aw-p228-passport__eyebrow">PASSEPORT NUMÉRIQUE AW</span><strong>${title}</strong><p>${body}</p></div>${actionHtml}`;
};
const esc=(v='')=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c]));
function findOwnedSource(code){
  let match=null;
  document.querySelectorAll('script[data-aw-owned-passport-code]').forEach(node=>{
    if(!match && String(node.dataset.awOwnedPassportCode||'')===String(code))match=node;
  });
  return match;
}
function parsePayload(node){
  try{const v=JSON.parse(node?.textContent||'{}');return v&&typeof v==='object'?v:null}catch(_){return null}
}
function eventType(e){
  const raw=`${text(e?.type)} ${text(e?.title)} ${text(e?.label)}`.toLowerCase();
  if(raw.includes('inspection')||raw.includes('contrôle')||raw.includes('controle'))return 'inspection';
  if(raw.includes('entretien')||raw.includes('maintenance')||raw.includes('révision')||raw.includes('revision'))return 'maintenance';
  if(raw.includes('atelier')||raw.includes('intervention')||raw.includes('repair')||raw.includes('réparation')||raw.includes('reparation'))return 'workshop_intervention';
  if(raw.includes('vente')||raw.includes('sold')||raw.includes('sale'))return 'purchase_order';
  if(raw.includes('entrée')||raw.includes('entree')||raw.includes('entry'))return 'occasion_entry';
  return 'passport_event';
}
function normalizeTimeline(payload){
  return arr(payload?.timeline).map((e,i)=>{
    const date=text(e?.date||e?.at||e?.occurred_at||e?.occurredAt||e?.checked_at||e?.completed_at||e?.sold_at||payload?.passportUpdatedAt);
    const ref=text(e?.reference||e?.ref||e?.id||`${payload.awNumber||'AW'}-${i+1}`);
    const title=text(e?.title||e?.label||e?.type||'Événement passeport AW');
    const summary=text(e?.summary||e?.description||e?.work||e?.customer_summary||e?.details);
    const parts=Array.isArray(e?.parts)?e.parts.map(text).filter(Boolean):[];
    const chrony=e?.chrony&&typeof e.chrony==='object'?e.chrony:null;
    const seed=`${payload.awNumber||payload.replicaId}|${ref}|${date}|${title}|${i}`;
    let hash=2166136261;
    for(let j=0;j<seed.length;j++){hash^=seed.charCodeAt(j);hash=Math.imul(hash,16777619)}
    return {
      id:`aw-passport-${(hash>>>0).toString(16)}`,
      replicaId:String(payload.replicaId),
      type:eventType(e),
      title,
      date,
      at:date,
      reference:ref,
      summary,
      parts,
      chrony,
      authority:'server',
      source:'aw_occasion_passport',
      active:true,
      awPassport:true,
      awNumber:text(payload.awNumber)
    };
  });
}
function mergeReplica(payload){
  const list=arr(read(K.replicas,[]));
  const id=String(payload.replicaId);
  const idx=list.findIndex(r=>String(r?.id||'')===id);
  const existing=idx>=0&&list[idx]&&typeof list[idx]==='object'?list[idx]:{};
  const patch={
    id,
    nickname:text(existing.nickname)||text(payload.model)||text(payload.title)||text(payload.awNumber)||'Réplique AW Occasion Airsoft',
    model:text(existing.model)||text(payload.model)||text(payload.title),
    manufacturer:text(existing.manufacturer)||text(payload.manufacturer),
    platform:text(existing.platform)||text(payload.platform),
    awNumber:text(payload.awNumber),
    source:text(existing.source)||'aw_occasion_passport',
    authority:text(existing.authority)||'server',
    awPassport:{
      reference:text(payload.passportReference),
      awNumber:text(payload.awNumber),
      productId:text(payload.productId),
      lifecycleStatus:text(payload.lifecycleStatus),
      enteredAt:text(payload.enteredAt),
      soldAt:text(payload.soldAt),
      updatedAt:text(payload.passportUpdatedAt),
      schemaVersion:Number(payload.schemaVersion||1)
    }
  };
  const merged={...existing,...patch};
  if(idx>=0)list[idx]=merged;else list.push(merged);
  write(K.replicas,list);
  return merged;
}
function mergeTimeline(payload){
  const current=arr(read(K.timeline,[]));
  const incoming=normalizeTimeline(payload);
  const map=new Map(current.map(e=>[String(e?.id||''),e]));
  incoming.forEach(e=>map.set(e.id,{...(map.get(e.id)||{}),...e}));
  write(K.timeline,Array.from(map.values()));
  return incoming.length;
}
function openDossier(id){
  try{localStorage.setItem(K.active,String(id))}catch(_){}
  window.dispatchEvent(new CustomEvent('aw:p2-garage-updated',{detail:{source:'p2.28-passport-qr',replicaId:String(id)}}));
  window.dispatchEvent(new CustomEvent('aw:replica-dossier-updated',{detail:{source:'p2.28-passport-qr',replicaId:String(id)}}));
  let tries=80;
  const go=()=>{
    const api=window.AWMonAtelierCenterP21;
    if(api?.openDossier){api.render?.();api.openDossier(String(id),'history');return}
    if(tries-->0)setTimeout(go,100);
  };
  go();
}
function start(){
  const code=token(); if(!code)return;
  const R=root(); if(!R)return;
  R.dataset.awP228PassportScan='true';
  const logged=R.dataset.accountAuthenticated==='true';
  if(!logged){
    const ret=`${location.pathname}${location.search}${location.hash}`;
    const href=`/account/login?return_url=${encodeURIComponent(ret)}`;
    setBanner('login','Connexion requise','Ce QR identifie une réplique AW Occasion Airsoft, mais il ne donne jamais accès au dossier sans le compte propriétaire.',`<a class="button" rel="nofollow" href="${href}">Se connecter à Mon Atelier</a>`);
    return;
  }
  const source=findOwnedSource(code);
  if(!source){
    setBanner('denied','Passeport non rattaché à ce compte','Ce code QR est valide comme sélecteur, mais aucun dossier appartenant au compte connecté ne lui correspond. Aucune donnée de la réplique n’a été ouverte.');
    return;
  }
  const payload=parsePayload(source);
  if(!payload?.replicaId||!payload?.awNumber){
    setBanner('error','Passeport indisponible','Le rattachement propriétaire est reconnu, mais le dossier n’est pas encore prêt. Contactez l’Atelier AW avec la référence de votre réplique.');
    return;
  }
  mergeReplica(payload);
  const count=mergeTimeline(payload);
  setBanner('granted','Passeport AW ouvert',`<strong>${esc(payload.awNumber)}</strong> · ${esc(payload.model||payload.title||'Réplique AW Occasion Airsoft')}. ${count} événement${count>1?'s':''} du passeport synchronisé${count>1?'s':''} dans ce dossier.`);
  openDossier(payload.replicaId);
}
window.AWOccasionPassportQR={version:VERSION,start,policy:'qr-is-selector-not-auth;current-owner-required;no-pii-in-token-or-card'};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();